// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { node, oneOf } from 'prop-types';

const Label = styled.span`
  background: ${ props => (props.variant === 'danger' ? '#fcf3f1' : '#edf8f5') };
  border: 1px solid ${ props => (props.variant === 'danger' ? '#e49a94' : '#73b5a5') };
  border-radius: 999px;
  color: ${ props => (props.variant === 'danger' ? props.theme.colors.red : '#236658') };
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  white-space: nowrap;
`;

const NWLabel = ({ children, variant = 'success' }) => (
  <Label variant={ variant }>
    { children }
  </Label>
);

NWLabel.propTypes = {
  children: node,
  variant: oneOf(['danger', 'success'])
};

export default NWLabel;
